import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GetStatesDoc, GetStatesQuery, GetStatesQueryVariables } from '@minecraft.graphql-operations';
import { BillingOption } from './useBillingCountries';

export const useBillingStates = (countryId?: number) => {
  const { data, loading, error } = useQuery<GetStatesQuery, GetStatesQueryVariables>(GetStatesDoc, {
    variables: { countryId: String(countryId) },
    skip: countryId == null,
  });

  return useMemo(() => {
    const stateOptions: BillingOption[] =
      data?.states?.reduce((stateOpts, state) => {
        if (!state?.code || !state?.name) {
          return stateOpts;
        }

        stateOpts.push({
          id: state.code,
          label: state.name,
        });

        return stateOpts;
      }, [] as BillingOption[]) ?? [];

    return {
      stateOptions,
      statesLoading: loading && countryId != null,
      statesError: error,
    };
  }, [countryId, data, error, loading]);
};
